import { render, staticRenderFns } from "./profil.vue?vue&type=template&id=fdfa1836&scoped=true"
import script from "./profil.vue?vue&type=script&lang=js"
export * from "./profil.vue?vue&type=script&lang=js"
import style0 from "./profil.vue?vue&type=style&index=0&id=fdfa1836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfa1836",
  null
  
)

export default component.exports